import AlbumImg from './images/OutoftheShadowsAlbum.png';
import SingleImg1 from './images/OutoftheShadowsSingle1.png';
import SingleImg2 from './images/OutoftheShadowsSingle2.png';
import SingleImg3 from './images/OutoftheShadowsSingle3.png';
import './Album.css';
import { useEffect } from 'react';

function Album() {

    useEffect(() => {
        // Scroll to the top of the page when the component mounts
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='album-page-container'>
            <Helmet>
                <title>Album Page</title>
                <meta name="description" content="Aethel's Albums. Listen here for her album content." />

                {/* Page-Specific Open Graph Tags */}
                <meta property="og:title" content="Album Page - Aethel Music" />
                <meta property="og:description" content="Aethel's Albums. Listen here for her album content." />
                <meta property="og:image" content="%PUBLIC_URL%/images/BiopicMedium.png" />
                <meta property="og:url" content="https://aethel.vercel.app/album" />

                {/* Page-Specific Twitter Card Tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Album Page - Aethel Music" />
                <meta name="twitter:description" content="Aethel's Albums. Listen here for her album content." />
                <meta name="twitter:image" content="%PUBLIC_URL%/images/BiopicMedium.png" />
            </Helmet>
            <div className='title' id='album-title'>
                <h1>Out of the Shadows</h1>
            </div>
            <div className='album'>
                <div id='album'><img src={AlbumImg} alt='Out of the Shadows Album'></img>
                    <button>Listen</button></div>
            </div>
            <h2 className='singles'>Single Tracks</h2>
            <div className='single'>

                <div className='imgblock'><img src={SingleImg1} alt='Warrior Single'></img>
                    <button className='singlebtns'>Sister</button></div>
                <div className='imgblock'><img src={SingleImg2} alt='Fog and Fire Single'></img>
                    <button className='singlebtns'>Thief</button></div>
                <div className='imgblock'><img src={SingleImg3} alt='Sandglass Single'></img>
                    <button className='singlebtns'>Sandglass</button></div>
                {/* <div className='imgblock'><img src={SingleImg3} alt='Sandglass Single'></img>
                    <button className='singlebtns'>Why Did We Ever</button></div> */}

            </div>

        </div>
    )

}

export default Album;
